import React from 'react';
import { Link } from 'react-router-dom';
import { Facebook, Twitter, Instagram, Linkedin, Mail, Clock } from 'lucide-react';

const Footer = () => {
  return (
    <footer className="bg-slate-900 text-white pt-16 pb-8">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12 mb-12">
          {/* About Section */}
          <div className="col-span-1">
            <div className="flex items-center space-x-3 mb-6">
              <div className="w-12 h-12 bg-gradient-to-br from-blue-500 to-blue-700 rounded-full flex items-center justify-center">
                <div className="w-10 h-10 border-2 border-white rounded-full flex items-center justify-center">
                  <span className="text-white font-bold text-lg">M</span>
                </div>
              </div>
            </div>
            <p className="text-gray-400 text-sm leading-relaxed">
              At Morgan Guaranty Trust, we are dedicated to helping individuals and businesses achieve financial confidence and success through trusted banking solutions.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-white font-semibold text-lg mb-6">Quick Links</h3>
            <ul className="space-y-3">
              <li>
                <Link to="/about" className="text-gray-400 hover:text-blue-400 transition-colors duration-200 flex items-center">
                  <span className="mr-2 text-blue-500">›</span> About Us
                </Link>
              </li>
              <li>
                <Link to="/corporate" className="text-gray-400 hover:text-blue-400 transition-colors duration-200 flex items-center">
                  <span className="mr-2 text-blue-500">›</span> Corporate Banking
                </Link>
              </li>
              <li>
                <Link to="/personal" className="text-gray-400 hover:text-blue-400 transition-colors duration-200 flex items-center">
                  <span className="mr-2 text-blue-500">›</span> Personal Banking
                </Link>
              </li>
              <li>
                <Link to="/insurance" className="text-gray-400 hover:text-blue-400 transition-colors duration-200 flex items-center">
                  <span className="mr-2 text-blue-500">›</span> Insurance
                </Link>
              </li>
              <li>
                <Link to="/contact" className="text-gray-400 hover:text-blue-400 transition-colors duration-200 flex items-center">
                  <span className="mr-2 text-blue-500">›</span> Contact
                </Link>
              </li>
            </ul>
          </div>

          {/* Our Services */}
          <div>
            <h3 className="text-white font-semibold text-lg mb-6">Our Services</h3>
            <ul className="space-y-3">
              <li>
                <Link to="/services/loans-mortgages" className="text-gray-400 hover:text-blue-400 transition-colors duration-200 flex items-center">
                  <span className="mr-2 text-blue-500">›</span> Loans & Mortgages
                </Link>
              </li>
              <li>
                <Link to="/services/savings-investments" className="text-gray-400 hover:text-blue-400 transition-colors duration-200 flex items-center">
                  <span className="mr-2 text-blue-500">›</span> Savings & Investments
                </Link>
              </li>
              <li>
                <Link to="/services/business-accounts" className="text-gray-400 hover:text-blue-400 transition-colors duration-200 flex items-center">
                  <span className="mr-2 text-blue-500">›</span> Business Accounts
                </Link>
              </li>
              <li>
                <Link to="/services/online-banking" className="text-gray-400 hover:text-blue-400 transition-colors duration-200 flex items-center">
                  <span className="mr-2 text-blue-500">›</span> Online Banking
                </Link>
              </li>
            </ul>
          </div>

          {/* Head Office */}
          <div>
            <h3 className="text-white font-semibold text-lg mb-6">Head Office</h3>
            <div className="space-y-4">
              <p className="text-gray-400">USA</p>
              <div className="flex items-start space-x-2">
                <Mail className="w-5 h-5 text-blue-500 mt-0.5" />
                <a href="mailto:supportdesk@mgtrustx.com" className="text-gray-400 hover:text-blue-400 transition-colors duration-200">
                  supportdesk@mgtrustx.com
                </a>
              </div>
              <div className="flex items-start space-x-2">
                <Clock className="w-5 h-5 text-blue-500 mt-0.5" />
                <p className="text-gray-400">Mon - Fri: 8:00 AM - 5:00 PM</p>
              </div>
              <p className="text-gray-400 flex items-center">
                <span className="inline-block w-2 h-2 bg-green-500 rounded-full mr-2"></span>
                Available 24/7
              </p>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-gray-800 pt-8 mt-8">
          <div className="flex flex-col md:flex-row justify-between items-center">
            <p className="text-gray-400 text-sm mb-4 md:mb-0">
              © Morgan Guaranty Trust | All Rights Reserved
            </p>
            <div className="flex space-x-4">
              <a href="#" className="w-10 h-10 bg-gray-800 hover:bg-blue-600 rounded-full flex items-center justify-center transition-colors duration-200">
                <Facebook className="w-5 h-5" />
              </a>
              <a href="#" className="w-10 h-10 bg-gray-800 hover:bg-blue-600 rounded-full flex items-center justify-center transition-colors duration-200">
                <Twitter className="w-5 h-5" />
              </a>
              <a href="#" className="w-10 h-10 bg-gray-800 hover:bg-blue-600 rounded-full flex items-center justify-center transition-colors duration-200">
                <Instagram className="w-5 h-5" />
              </a>
              <a href="#" className="w-10 h-10 bg-gray-800 hover:bg-blue-600 rounded-full flex items-center justify-center transition-colors duration-200">
                <Linkedin className="w-5 h-5" />
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
